(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ReportsBuilderKarcherController', reportsBuilderKarcher);

  /** @ngInject */
  function reportsBuilderKarcher(
    KarcherBuilderReportsViewModel,
    $log,
    reportActions,
    layoutActions,
    $filter,
    weatherKarcherActions,
    $translate,
    exportToCsv,
    reportExportUtil,
    helperService,
    $scope,
    $timeout,
    AppStateService
  ) {
    var vm = this,
      tablePageSize = 10,
      tablePage = 1;
    vm.reportBuilderViewModel = new KarcherBuilderReportsViewModel();

    init();

    vm.itemSelected = function (item) {
      $timeout(function () {
        $scope.karcherReportsBuilderForm.$invalid = item;
      });
    };

    vm.getReport = function () {
      layoutActions.showLoader();
      if (!vm.reportBuilderViewModel.isChartIncluded) {
        vm.reportBuilderViewModel.reportBodyData.pageSize = tablePageSize;
        vm.reportBuilderViewModel.reportBodyData.page =
          (tablePage - 1) * tablePageSize;
      } else if (vm.reportBuilderViewModel.reportBodyData.facilityId) {
        refreshWeatherHistoryData();
      }
      var reportDataObject = angular.copy(
        vm.reportBuilderViewModel.reportBodyData
      );
      reportDataObject.from =
        reportDataObject.from - reportDataObject.offsetFrom;
      reportDataObject.to = reportDataObject.to - reportDataObject.offsetTo;
      reportActions
        .executeDynamicReport(
          vm.reportBuilderViewModel.selectedReport,
          reportDataObject
        )
        .then(function (reportResponse) {
          if (reportResponse.status === 204) {
            vm.reportBuilderViewModel.isChartVisible = false;
            layoutActions.hideLoader();
            return;
          }
          vm.reportBuilderViewModel.isChartIncluded
            ? vm.reportBuilderViewModel.refreshKarcherReportsData(
                reportResponse.data
              )
            : vm.reportBuilderViewModel.refreshKarcherReportsTableData(
                reportResponse.data
              );
        });
    };

    vm.exportToCsvReports = function () {
      var fileTitleData = [];
      fileTitleData.push(
        vm.reportBuilderViewModel.reportNameList.filter(function (item) {
          return item.id === vm.reportBuilderViewModel.selectedReport;
        })[0].name
      );
      fileTitleData.push(
        $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.from,
          'dd-MM-yyyy'
        )
      );
      fileTitleData.push(
        $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.to,
          'dd-MM-yyyy'
        )
      );
      // Extend csv report with totals for Karcher brand. I don't want to update reportExportUtils because of R2W reporting
      if (!vm.reportBuilderViewModel.isTableVisible) {
        vm.reportBuilderViewModel.chartData.data.groupsData.unshift({
          groupValue: 'Total',
          values: vm.reportBuilderViewModel.chartData.data.groupTotal
        });
        var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.reportBuilderViewModel.chartData.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER
        );

        exportToCsv.export(
          jsonArrayForExport,
          helperService.createFileName(fileTitleData),
          true
        );
      } else {
        exportToCsv.exportBasicArrayToCsv(
          vm.reportBuilderViewModel.tableChartData.data,
          fileTitleData[0] + '.csv'
        );
      }
    };

    vm.changeReportName = function () {
      layoutActions.showLoader();
      vm.reportBuilderViewModel.reportBodyData = {};
      vm.reportBuilderViewModel.dependsOnData = {};
      vm.reportBuilderViewModel.getReportGrouping(
        vm.reportBuilderViewModel.selectedReport
      );
      reportActions
        .getSelectedReportConfiguration(
          vm.reportBuilderViewModel.selectedReport
        )
        .then(function (response) {
          /* eslint-disable */
          if (response.responseConfiguration) {
            vm.reportBuilderViewModel.chartData.chartType = JSON.parse(
              response.responseConfiguration
            ).chartType;
            vm.reportBuilderViewModel.chartData.x.type = JSON.parse(
              response.responseConfiguration
            ).chartXAxisType
              ? JSON.parse(response.responseConfiguration).chartXAxisType
              : 'timeseries';
            vm.reportBuilderViewModel.isChartIncluded = response.chart;
            vm.reportBuilderViewModel.isChartVisible = false;
            vm.reportBuilderViewModel.isTableVisible = false;
            vm.reportBuilderViewModel.refreshConfigurationData(
              JSON.parse(response.parameterConfiguration)
            );
            layoutActions.hideLoader();
          } else {
            layoutActions.hideLoader();
            console.log('No responseConfiguration');
          }
        });
    };

    vm.clearMultiplyInput = function (inputData) {
      inputData.model = '';
    };

    vm.getItems = function (ids, inputData) {
      inputData.model = ids;
      if (inputData.dependsOn === null) {
        parseSelectedPathAndReplaceIt(
          ids,
          vm.reportBuilderViewModel.dependsOnData,
          vm.reportBuilderViewModel.reportBuilderData
        );
      }
      vm.reportBuilderViewModel.getTimezoneForSelectedFacility(
        vm.reportBuilderViewModel.washFacilityList.filter(function (facility) {
          return facility.id === ids;
        })
      );
      if (inputData.inputName !== '') {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] =
          inputData.model;
      }
    };

    vm.onChangeInputs = function (inputData) {
      $timeout(function () {
        $scope.karcherReportsBuilderForm.$invalid = false;
      });
      if (inputData.type === 'date-input') {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] = isDate(
          inputData.model
        )
          ? new Date(inputData.model).getTime()
          : inputData.model;
        if (inputData.inputName === 'from') {
          AppStateService.setState('fromModel', inputData.model);
          vm.reportBuilderViewModel.reportBodyData.offsetFrom =
            inputData.model.getTimezoneOffset() * 60000;
        } else {
          AppStateService.setState('toModel', inputData.model);
          vm.reportBuilderViewModel.reportBodyData.offsetTo =
            inputData.model.getTimezoneOffset() * 60000;
        }
      } else {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] =
          inputData.model;
      }
    };

    vm.updateTablePagination = function (page, limit) {
      tablePageSize = limit;
      tablePage = page;
      vm.getReport();
    };

    function init() {
      reportActions.getAllReportConfigurations().then(function (response) {
        vm.reportBuilderViewModel.refreshKarcherReportsList(response);
      });
    }

    function isDate(input) {
      return Object.prototype.toString.call(input) === '[object Date]';
    }
    /* eslint-enable */

    function refreshWeatherHistoryData() {
      var selectedItem = vm.reportBuilderViewModel.washFacilityList.filter(
          function (item) {
            return (
              item.id === vm.reportBuilderViewModel.reportBodyData.facilityId
            );
          }
        ),
        selectedDateFrom = $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.from,
          'yyyy-MM-dd'
        ),
        selectedDateTo = $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.to,
          'yyyy-MM-dd'
        );

      weatherKarcherActions
        .getHistoryWeather(
          selectedItem[0].location.latitude,
          selectedItem[0].location.longitude,
          selectedDateFrom,
          selectedDateTo
        )
        .then(function (weatherData) {
          vm.reportBuilderViewModel.refreshWeatherHistoryData(weatherData);
        });
    }

    function parseSelectedPathAndReplaceIt(
      parameter,
      dependsOnData,
      configurationData
    ) {
      if (dependsOnData.dependsOn && dependsOnData.dependsOn !== '') {
        var pathPattern = /\/api\/washFacilities\/[^\/]+\/washFacilityBoxes/;
        var newPath = '/api/washFacilities/' + parameter + '/washFacilityBoxes';

        if (pathPattern.test(dependsOnData.selectorPath)) {
          dependsOnData.selectorPath = newPath;
        } else {
          dependsOnData.selectorPath = dependsOnData.selectorPath.replace(
            '{parameter}',
            parameter
          );
        }

        configurationData.forEach(function (item) {
          if (item.inputName === dependsOnData.inputName) {
            item.selectorPath = dependsOnData.selectorPath;
            item.model = parameter + 111;
            vm.reportBuilderViewModel
              .getDynamicList(item.selectorPath, item.selectorHeader)
              .then(function (data) {
                console.log('data_for_depends_on_input: ', data);
                item.selectorList = data;
              });
          }
        });

        return configurationData;
      }
    }
  }
})();
